export const IMPORT_STEP_UPLOAD_FILE = 0;
export const IMPORT_STEP_PREVIEW_FILE = 1;
export const IMPORT_STEP_CONFIRMATION = 2;

export const IMPORT_TYPE_USERS = 'users';
export const IMPORT_TYPE_CONNECTED_PARTIES = 'connectedParties';
export const IMPORT_TYPE_APPOINTMENTS = 'appointments';
